module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"来店客数週間予測","disclaimer":"データ元：Flow AIによる予測"}}')
  delete Component.options._Ctor
}
